import { isWeb } from 'shared/constants/platform';
import { getCvvDataKey } from 'shared/providers/environment';
import {
  getItemSecureStore,
  setItemSecureStore,
} from 'shared/utils/secureStore/secureStore';

export const getCardCvvData = async (cardId: string) => {
  return !isWeb
    ? ((await getItemSecureStore(getCvvDataKey(cardId))) ?? null)
    : null;
};

export const saveCardCvvData = async (cardId: string, cvvData: string) => {
  if (!isWeb) {
    // all errors are caught and logged in setItemSecureStore
    await setItemSecureStore(getCvvDataKey(cardId), cvvData);
  }
};
